import { UseMutationOptions, useMutation, useQueryClient } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { TLM_MASTER } from "../apiRoutes";

const mutateToggleTlmMaster = async ({ id }: { id: string | number }) => {
	return await axiosAuth.patch(`${TLM_MASTER}${id}`);
};

const useToggleTlmMaster = (
	queryParams?: UseMutationOptions<
		any,
		Error,
		{
			id: string | number;
		},
		unknown
	>
) => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: mutateToggleTlmMaster,
		onSuccess: (data, variables, context) => {
			queryClient.invalidateQueries({ queryKey: ["tlmMaster"], exact: false });
			queryParams?.onSuccess?.(data, variables, context);
		},
		...queryParams,
	});
};

export default useToggleTlmMaster;
